<template>
    <div>
        <div class="ui active loader" v-if="!is_initialized">
            <div class="ui text loader">
                <!-- 載入貨況中 -->
                {{ $t('ui.general.initializing') }}
            </div>
        </div>

        <div class="ui top attached tabular menu"
            style="background: white;"
            v-if="is_initialized && current_statuses.length">
            <div class="item pointer"
                v-for="(current_statuses_group_by_scope, key) in current_statuses_group_by_scopes"
                @click="reset_current_statuses(key)"
                :class="{
                    'active': current_statuses_scope == key
                }">
                {{ $t('ui.pages.core_waybills.status.'+key) }}
            </div>
        </div>

        <div class="ui small steps no top border" v-if="is_initialized">
            <Status
                v-if="current_statuses.length"
                v-for="status in current_statuses"
                class="step no border"
                :class="{active: status.identity == current_statuses}"
                :key="status.identity"
                :is_show_staff="true"
                :scope="scope"
                :status="status"
            >
            </Status>
            <div
                v-if="current_statuses.length == 0"
                class="step no border">
                <h3>
                    {{ $t('ui.pages.core_waybills.status.no_latest_status') }}
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
import Status from './status.vue'

export default {
    components: {
        Status,
    },
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        scope: {
            default: 'provider',
            type: String
        },
        statuses: {
            default: () => { return [] },
            type: Array
        },
    },
    data() {
        return {
            is_initialized: false,
            current_statuses_scope: "",
            current_statuses: [],
            current_statuses_group_by_scopes: {},
        }
    },
    watch: {
        'core_waybill.statuses': {
            deep: true,
            handler() {
                this.init()
            },
        },
        statuses: {
            deep: true,
            handler() {
                this.init()
            },
        },
    },
    created() {
    },
    mounted() {
        this.init()
    },
    computed: {
    },
    methods: {
        async init() {
            this.is_initialized = false
            await this.set_current_statuses()
            await this.set_current_statuses_group_by_scopes()
            await this.fetch_current_statuses_staffs()
            await this.reset_current_statuses()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        set_current_statuses() {
            if (this.statuses.length != 0) {
                this.current_statuses = $.extend(true, [], this.statuses)
            } else {
                this.current_statuses = $.extend(true, [], this.core_waybill.statuses)
            }
            return Promise.resolve()
        },
        set_current_statuses_group_by_scopes() {
            this.current_statuses_group_by_scopes = _.groupBy(this.current_statuses, "scope")
            return Promise.resolve()
        },
        reset_current_statuses(scope_name = "") {
            // 沒有, 則取第一個
            if (scope_name == "") {
                var is_get_order = false
                _.forEach(['operator', 'forwarder', 'public', 'system'], (order_name) => {
                    if (!is_get_order) {
                        if (
                            _.findLast(Object.keys(this.current_statuses_group_by_scopes), (scope_name) => {
                                return scope_name == order_name
                            })
                        ) {
                            this.current_statuses_scope = order_name
                            this.current_statuses = this.current_statuses_group_by_scopes[this.current_statuses_scope]
                            is_get_order = true
                        }
                    }
                })
                // for each 沒有最好排序 取第一筆
                if (!is_get_order) {
                    this.current_statuses_scope = Object.keys(this.current_statuses_group_by_scopes)[0]
                    this.current_statuses = this.current_statuses_group_by_scopes[this.current_statuses_scope] || []
                }

            } else {
                this.current_statuses_scope = scope_name
                this.current_statuses = this.current_statuses_group_by_scopes[scope_name] || []

            }
            return Promise.resolve()
        },
        fetch_current_statuses_staffs() {
            if (this.scope != 'provider') {
                return Promise.resolve()
            }

            var group_by_operator_identity = _.groupBy(this.current_statuses, "operator_identity")
            _.forEach(group_by_operator_identity, (value, key) => {
                if (key != 'null') {
                    var operator_type = _.last(value).operator_type
                    if (operator_type == "Staff") {
                        this.$store.dispatch('provider/tool_core_waybill_module/fetch_staff', {
                            operator_identity: key
                        })
                    }
                    if (operator_type == "Customer") {
                        this.$store.dispatch('provider/tool_core_waybill_module/fetch_customer', {
                            operator_identity: key
                        })
                    }
                }
            })

            return Promise.resolve()
        },
    },
}
</script>

<style scoped lang="scss">
    @media only screen and (max-width: 767px) {
        .ui.steps {
            max-height: 240px;
            overflow-y: auto !important;
        }
    }
    .ui.steps {
        margin-top: 0;
        margin-bottom: 10px !important;
        overflow-y: hidden;
        overflow-x: auto;
        width: 100%;
    }
</style>
